<template>
  <div>
    <ModelBanner />
    <ModelInfo1 />
    <ModelInfo2 />
    <Footer />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { url } from '@zz-common/zz-utils'
import ModelBanner from '@/components/ModelBanner.vue'
import ModelInfo1 from '@/components/ModelInfo1.vue'
import ModelInfo2 from '@/components/ModelInfo2.vue'
import Footer from '@/components/Footer.vue'

let lang = url.getParam('lang') || ''

export default Vue.extend({
  name: 'container-view',
  components: {
    ModelBanner,
    ModelInfo1,
    ModelInfo2,
    Footer
  },

  created() {
    // lang如果是en，就设置为en，其它情况设置为zh-cn
    lang = lang.includes('en') ? 'en' : 'zh-cn'
    this.$store.commit('switchLang', lang)

    // 如果页面分辨率大于1280，则给html设置overflow-x: hidden
    if (window.innerWidth > 1200) {
      document.documentElement.style.overflowX = 'hidden'
    }

    if (lang === 'en') {
      document.title = 'Save money. Save the world.'
    } else {
      document.title = '二手拯救世界'
    }
  }
})
</script>
